import Link from "next/link";
import { Stack } from "@mui/material";
import { MdInfoOutline } from "react-icons/md";

import { routes } from "src/shared/routes";
import { useRouterExt } from "src/components/reusable/hooks/useRouterExt";

import { SSText } from "src/components/base/components/SSText";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";
import type { TRegistrationCardData } from "src/shared/types/globalStotre.types";

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Olympic Sports Ticket Benefits",
    description:
      "Claim your free tickets for upcoming Olympic Sporting events!",
    authRedirectPage: routes.home,
    buttonLabel: "View Available Offers",
  },
];

export const TERMS_AND_CONDITION = () => (
  <>
    By purchasing you agree to receive SMS alerts regarding ticket delivery and
    agree to the{" "}
    <Link target="_blank" href="https://www.attend.tech/terms-of-use">
      Terms of Use
    </Link>{" "}
    and{" "}
    <Link target="_blank" href="https://www.attend.tech/privacy-policy">
      Privacy Policy
    </Link>
    .
  </>
);

export const ADD_ON_PURCHASE_SUCCESS_MESSAGE = {
  TITLE: () => <>You&apos;re all set to experience the action!</>,
  DESCRIPTION: () => {
    const router = useRouterExt();
    return (
      <>
        View your tickets{" "}
        <b>
          <u>
            <Link
              href="https://am.ticketmaster.com/isu/"
              target="_blank"
              style={{ color: "#F1BE48" }}
            >
              here
            </Link>
          </u>
        </b>
        .
      </>
    );
  },
};
